/* eslint-disable linebreak-style */
import { fetchExcludedMakes } from '../fetchers';
import { fetchWithCache } from '.';

const getMakeKey = (isSeoMakeATC, make) => (isSeoMakeATC ? make.name : make.makeName)?.toLowerCase();

export default async function filterOutExcludedMakes(isSeoMakeATC, makeList) {
    try {
        const s3Response = await fetchWithCache(
            fetchExcludedMakes,
            null,
            's3-exclude-makes',
            3600000 // 1 hour
        );
        const excludedMakes = (s3Response?.makes ?? []).map((excludedMake) => excludedMake.toLowerCase());

        return makeList.filter((make) => !excludedMakes.includes(getMakeKey(isSeoMakeATC, make)));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching excluded makes from S3:', error);
        return makeList;
    }
}
